export default "__VITE_ASSET__CIyHDTSd__"